<ion-header>
	<app-account-toolbar [icon]='"person-add"' [title]='"sign_up.title"' (back)="close()"></app-account-toolbar>
</ion-header>
<ion-content>
	<ion-row class="ion-justify-content-center">
		<ion-col class="ion-padding wrap" size="12" size-lg="4" size-md="6">
			<h1>{{'email_confirmation.confirmation_send' | translate}}</h1>
			<p class="text-large">{{'email_confirmation.hello' | translate }}, {{'email_confirmation.account_confirmation' | translate}}</p>
		</ion-col>
	</ion-row>
</ion-content>

<ion-footer>
	<ion-row class="ion-justify-content-center">
		<ion-col class="ion-padding" size="12" size-lg="4" size-md="6">
			<ion-button (click)="close()" expand="block">
				<ng-container *ngIf="!loading">{{'email_confirmation.update' | translate}}</ng-container>
				<ion-spinner *ngIf="loading"></ion-spinner>
			</ion-button>
		</ion-col>
	</ion-row>
</ion-footer>
